import PropTypes from 'prop-types';

import {copyableProperty} from '../common';

/**
 * Display value for Sport
 */
export const sport = (event) => copyableProperty(
    {
        data: event,
        srWithMatchID: ['match', 'tournament', 'tournament_category', 'sport'],
        srWithoutMatchID: ['tournament', 'tournament_category', 'sport'],
    },
    'Sport'
);

sport.propTypes = {
    event: PropTypes.object.isRequired,
};
